module.exports = __webpack_public_path__ + "img/settings.6bc88f94.svg";